import { Link } from "react-router-dom";
import Logo from "components/Logos/Logo_NoText";
import { Button } from "react-bootstrap";

export default function NotFound() {
  return (
    <div className="p-5">
      <Logo />
      <h1 style={{ "font-size": "7.2rem" }}>404</h1>
      <p>
        We are sorry for inconvenience. It looks you’re trying to access a page
        that either has been deleted or doesn't exist.
      </p>
      <Button
        style={{
          border: "1px solid var(--main-white)",
          borderRadius: "0",
          backgroundColor: "transparent",
          padding: "1rem 2rem",
        }}
      >
        <Link
          to="/"
          style={{
            color: "var(--main-white)",
            "text-transform": "uppercase",
            "text-decoration": "none",
          }}
        >
          Back to Home
        </Link>
      </Button>
    </div>
  );
}
